import { render, staticRenderFns } from "./RatingView.vue?vue&type=template&id=15f360a6&scoped=true&"
import script from "./RatingView.vue?vue&type=script&lang=js&"
export * from "./RatingView.vue?vue&type=script&lang=js&"
import style0 from "./RatingView.vue?vue&type=style&index=0&id=15f360a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f360a6",
  null
  
)

export default component.exports